import "../styles/legal.css";
import bg from "../assets/bg.png";

export default function PrivacyPage() {
  return (
    <main className="legal" style={{ backgroundImage: `url(${bg})` }}>
      <div className="legal__overlay" />

      <section className="legal__card">

        {/* HEADER */}
        <div className="legal__header">
          <h1 className="legal__title">
            POLÍTICA <span>DE PRIVACIDAD</span>
          </h1>

          <p className="legal__subtitle">
            Última actualización: 2026
          </p>
        </div>

        {/* CONTENT */}
        <div className="legal__content">

          <div className="legal__block">
            <h3>1. Información que recopilamos</h3>
            <p>
              Podemos recopilar información personal como nombre, correo electrónico,
              credenciales de acceso y datos de uso dentro de la plataforma.
            </p>
          </div>

          <div className="legal__block">
            <h3>2. Uso de la información</h3>
            <p>
              Utilizamos la información para operar el servicio, mejorar la experiencia del usuario
              y brindar soporte técnico.
            </p>
          </div>

          <div className="legal__block">
            <h3>3. Base legal del tratamiento</h3>
            <p>
              Procesamos datos bajo consentimiento del usuario, obligaciones legales o interés legítimo
              relacionado con el funcionamiento del sistema.
            </p>
          </div>

          <div className="legal__block">
            <h3>4. Seguridad de la información</h3>
            <p>
              Aplicamos medidas técnicas y organizativas para proteger los datos contra accesos no autorizados,
              pérdida o alteración.
            </p>
          </div>

          <div className="legal__block">
            <h3>5. Compartición de datos</h3>
            <p>
              No vendemos datos personales. Solo compartimos información cuando es necesario para operar el servicio
              o por obligación legal.
            </p>
          </div>

          <div className="legal__block">
            <h3>6. Conservación de datos</h3>
            <p>
              Los datos se conservan únicamente durante el tiempo necesario para cumplir con los fines del servicio
              o requerimientos legales.
            </p>
          </div>

          <div className="legal__block">
            <h3>7. Derechos del usuario</h3>
            <p>
              El usuario puede solicitar acceso, modificación o eliminación de sus datos personales
              en cualquier momento.
            </p>
          </div>

          <div className="legal__block">
            <h3>8. Cookies</h3>
            <p>
              Usamos cookies para mejorar la experiencia del usuario y analizar el uso de la plataforma.
            </p>
          </div>

          <div className="legal__block">
            <h3>9. Servicios de terceros</h3>
            <p>
              Podemos integrar servicios externos con sus propias políticas de privacidad.
            </p>
          </div>

          <div className="legal__block">
            <h3>10. Cambios en la política</h3>
            <p>
              Esta política puede actualizarse en cualquier momento. Los cambios serán publicados dentro de la plataforma.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
}